import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { tap, catchError, finalize } from 'rxjs/operators';
import { InvestigationFormRepository } from '../../../infrastructure/repositories/investigation-form.repository';
import { InvestigationFormState } from '../../states/investigation-form.state';

@Injectable({ providedIn: 'root' })
export class DeleteInvestigationFormUseCase {
  private readonly _repository = inject(InvestigationFormRepository);
  private readonly _state = inject(InvestigationFormState);

  public execute(id: string): Observable<void> {
    this._state.setSavingInvestigationForm(true);
    this._state.clearErrorInvestigationForms();

    return this._repository.deleteInvestigationForm(id).pipe(
      tap(() => {
        this._state.removeInvestigationForm(id);
      }),
      catchError((error) => {
        const errorMessage = error?.error?.message || error?.message || 'Failed to delete investigation form';
        this._state.setErrorInvestigationForms(errorMessage);
        throw error;
      }),
      finalize(() => this._state.setSavingInvestigationForm(false))
    );
  }
}
